/* Parwin Top Seller: the badge marks ONE variant (colour + size).
   - On the colour thumbnail, the badge is visible only while the top-seller SIZE is selected
     (different size = different variant = no badge).
   - On load, open the product on the top-seller variant so the badge shows first
     (unless the URL already targets a specific ?variant). */
(function () {
  if (window.__parwinTopSeller) return;
  window.__parwinTopSeller = true;

  function initPicker(picker) {
    var tsColor = (picker.getAttribute('data-ts-color') || '').trim();
    var tsSize = (picker.getAttribute('data-ts-size') || '').trim();
    if (!tsColor && !tsSize) return;

    function selectedSize() {
      var r = picker.querySelector('.vo--size input[type="radio"]:checked');
      return r ? (r.value || '').trim() : '';
    }
    function updateBadge() {
      var badge = picker.querySelector('.pp-topseller:not(.pp-topseller--btn)');
      if (!badge) return;
      if (!tsSize) { badge.style.display = ''; return; } // colour-only: always
      badge.style.display = (selectedSize() === tsSize) ? '' : 'none';
    }
    function pick(scopeSel, val) {
      if (!val) return;
      var radios = picker.querySelectorAll(scopeSel + ' input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        if ((radios[i].value || '').trim() === val) {
          if (!radios[i].checked) { radios[i].checked = true; radios[i].dispatchEvent(new Event('change', { bubbles: true })); }
          return;
        }
      }
    }

    // open on the top-seller variant (unless a specific variant was requested in the URL)
    if (!/[?&]variant=/.test(location.search)) {
      pick('.vo--size', tsSize);
      pick('.vo--colour', tsColor);
    }
    updateBadge();
    picker.addEventListener('change', function (e) { if (e.target && e.target.type === 'radio') updateBadge(); });
    document.addEventListener('variant:update', updateBadge);
  }

  function ready() {
    document.querySelectorAll('variant-picker[data-ts-color], variant-picker[data-ts-size]').forEach(initPicker);
  }
  if (document.readyState !== 'loading') ready(); else document.addEventListener('DOMContentLoaded', ready);
})();
